import React, { useEffect, useState } from "react";
import MailSidebar from "../components/MailSidebar";
import MailList from "../components/MailList";
import MailDetail from "../components/MailDetail";
import { useAuthContext } from "../context/AuthContext"; 
import { apiRequest } from "../utils/api"; // ← 追加
import { useAlert } from '../components/AlertModal';
import "../styles/MailPage.css";

const MailPage = () => {
  const [selectedEmailId, setSelectedEmailId] = useState(null);
  const [currentFolder, setCurrentFolder] = useState("inbox");
  const [reloadTrigger, setReloadTrigger] = useState(0);
  const [emails, setEmails] = useState([]);
  const { user: userInfo} = useAuthContext(); // Contextから取得
  const [storeId, setStoreId] = useState("1");
  const [draftId, setDraftId] = useState(null);
  const { showAlert } = useAlert();

  useEffect(() => {
    if (userInfo?.store_id) {
      setStoreId(userInfo.store_id);
    }
  }, [userInfo]);

  const triggerReload = () => {
    setReloadTrigger((prev) => prev + 1);
  };

  // ✅ ページを開いたときにIMAPからメール受信
  useEffect(() => {
    const fetchNewEmails = async () => {
      try {
        const res = await apiRequest("inventory/mail/fetch/");
        if (res.status === "success" && res.new_emails > 0) {
          showAlert(`新着メールを ${res.new_emails} 件受信しました`);
          triggerReload(); // 一覧更新
        }
      } catch (error) {
        console.error("メール受信エラー:", error);
      }
    };

    fetchNewEmails(); // 初回のみ実行
  }, [showAlert]);

  const handleFetchNewEmails = async () => {
    try {
      const res = await apiRequest("inventory/mail/fetch/");
      if (res.status === "success" && res.new_emails > 0) {
        showAlert(`新着メールを ${res.new_emails} 件受信しました`);
        triggerReload(); // ← 一覧更新
      } else {
        showAlert("新着メールはありません");
      }
    } catch (error) {
      console.error("メール受信エラー:", error);
      showAlert("メールの受信に失敗しました");
    }
  };

  
  const handleRemoveEmail = (id) => {
    setEmails((prev) => prev.filter((e) => e.id !== id));
  };
  const handleRestoreEmail = (id) => {
    setEmails((prev) => prev.filter((e) => e.id !== id));
  };

  const handleFolderChange = (folder) => {
    setCurrentFolder(folder);
    setSelectedEmailId(null);  // ← フォルダ変更時に詳細もリセット！
  };

  return (
    <div className="mail-page-container">
      <MailSidebar currentFolder={currentFolder} reloadTrigger={reloadTrigger} onFolderChange={handleFolderChange} onReloadClick={handleFetchNewEmails}/>
      <div className="mail-main-area">
        <MailList
          onSelect={setSelectedEmailId}
          currentFolder={currentFolder}
          onReload={triggerReload}
          emails={emails}
          setEmails={setEmails}
          isSentList={currentFolder === "sent"}
          isDraftList={currentFolder === "draft"}
          selectedEmailId={selectedEmailId}

        />
        <MailDetail
          emailId={selectedEmailId}
          currentFolder={currentFolder}
          onReload={triggerReload}
          onClose={() => setSelectedEmailId(null)}
          onSoftDelete={handleRemoveEmail}
          onRestore={handleRestoreEmail}
          isReadOnly={currentFolder === "sent"}
          isDraftList={currentFolder === "draft"}
          storeId={storeId}
          draftId={draftId}
          setDraftId={setDraftId}
          setSelectedEmailId={setSelectedEmailId}
          setEmails={setEmails}
        />
      </div>
    </div>
  );
};

export default MailPage;
